<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <div class="common-form">基本信息</div>

            <el-form-item label="所属部门">
                <el-select v-model="form.dept_id" placeholder="请选择" clearable @change="depParentChang">
                    <el-option v-for="(item, index) in dept_tree" :label="item.name" :value="item.dept_id" :key="index"> {{item.prefix}}{{item.name}} </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户姓名" prop="name" :rules="{required: true, message: '字段不能为空', trigger: 'blur'}">
                <el-input v-model="form.name" placeholder="用户姓名" clearable/>
            </el-form-item>

            <el-form-item label="身份证号" prop="id_number" :rules="{required: true, message: '字段不能为空', trigger: 'blur'}">
                <el-input v-model="form.id_number" placeholder="身份证号" clearable/>
            </el-form-item>

            <el-form-item label="学号" prop="student_number" >
                <el-input v-model="form.student_number" placeholder="学号" clearable/>
            </el-form-item>


            <el-form-item label="密码" prop="password">
                <el-input v-model="form.password" placeholder="用户密码" clearable/>
                <div class="tips">编辑时为空不修改</div>
            </el-form-item>

            <el-form-item label="电话" prop="mobile">
                <el-input v-model="form.mobile" placeholder="电话" clearable/>
            </el-form-item>

            <el-form-item label="学生/家长电话号码" prop="parent_mobile">
                <el-input v-model="form.parent_mobile" placeholder="学生/家长电话号码" clearable/>
            </el-form-item>

            <el-form-item label="生日" prop="birthday_show_str">
                <el-date-picker
                    v-model="form.birthday_show_str"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="性别" prop="gender">
                <el-select v-model="form.gender" placeholder="请选择性别">
                    <el-option label="女" :value="0" />
                    <el-option label="男" :value="1" />
                    <el-option label="未知" :value="2" />
                </el-select>
            </el-form-item>

            <div class="common-form">扩展信息</div>

            <el-form-item v-for="(item, index) in form.user_fields" :label="item.field_name" :key="index" prop="mobile">
                <el-input v-model="form.user_fields[index].field_value" :placeholder="item.field_name" clearable/>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

<!--            <el-form-item label="排序" prop="sort">-->
<!--                <el-input v-model.number="form.sort" autocomplete="off"></el-input>-->
<!--                <div class="tips">越小越靠前</div>-->
<!--            </el-form-item>-->

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {companyUserEdit, getListChildrenTree, companyUserDetail} from '@/api/education';

    export default {
        components: { },
        data() {
            return {
                title: '',
                form: {
                    member_id: '',
                    dept_id: '',
                    company_id: 0,
                    name: '',
                    age:1,
                    student_number:'',
                    id_number:'',
                    account:'',
                    password:'',
                    parent_mobile:'',
                    birthday:'',
                    birthday_show_str:'',
                    gender:'',
                    status: 1,
                    sort: 1,
                    user_fields: [],
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入名称',
                        trigger: 'blur'
                    }]
                },
                dept_tree: [],
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加用户'
                } else {
                    this.title = '编辑用户'
                    this.form.member_id = row.member_id
                    this.form.company_id = row.company_id
                    this.getDetail()
                }
                this.deptTree()
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.form.content = ''
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        companyUserEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            deptTree(){
                console.log(this.form.company_id)
                getListChildrenTree({company_id: this.form.company_id}).then((r)=>{
                    this.dept_tree = r.data.list
                })
            },
            depParentChang(val){
                this.form.dept_id = val
            },
            getDetail(){
                companyUserDetail({id: this.form.member_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                })
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/dept/dept/user-edit.vue